import React from 'react';
import styleControlloCF from './ControlloCF.module.scss';
import moment from 'moment';
import { useSelector } from 'react-redux';

const ControlloCF = (props) => {

    const datiCF = useSelector(state =>  state.dataReducer.datiCodiceFiscale || {});
    const sessoCF = datiCF.sesso || '';
    const loadingCodiceFiscale = props.loading;

    return (
        (loadingCodiceFiscale === true || sessoCF !== '') ? (
            <div className={styleControlloCF.ControlloCF}>
                <p><span className={styleControlloCF.strong}>Sesso:</span> {datiCF.sesso !== '' ? `${datiCF.sesso}` : ` Caricamento in corso...` }</p>
                <p><span className={styleControlloCF.strong}>Comune di nascita:</span> { datiCF.comuneNascita !== '' ? `${datiCF.comuneNascita}` :` Caricamento in corso...` } { datiCF.provinciaNascita !== ""  ? `(${datiCF.provinciaNascita})` : null }</p>
                <p><span className={styleControlloCF.strong}>Data di nascita:</span> {  datiCF.dataNascita !== '' ? moment(datiCF.dataNascita).format('DD/MM/YYYY')  : ` Caricamento in corso...` }</p>
            </div>
        ) : null
    )
}

export default ControlloCF;